/**
 * 代理门户登录后门禁状态纯函数（AC-6 / SPRINT-WEB-CRITICAL）。
 *
 * `/auth/me` 探测失败时必须进入 error 态并提供重试，**绝不放行**受保护业务路由；
 * 唯一例外是「改密 / 2FA 设置页」路径（否则错误态下「去设置」按钮成死链）。
 * 纯函数、零 React 依赖（node --experimental-strip-types 可直测）。
 */

/** 门禁阶段：loading=探测中；ready=me 成功；error=失败（可重试） */
export type SetupPhase = 'loading' | 'ready' | 'error';

/** `/auth/me` 结果最小面 */
export type MeResultLike = { ok: true } | { ok: false; code?: string } | null | undefined;

/** me 结果 → 门禁阶段（仅 ok:true 为 ready；其余含异常/否定均为 error） */
export function phaseFromMe(res: MeResultLike): SetupPhase {
  return res?.ok === true ? 'ready' : 'error';
}

/**
 * 设置页路径判定：改密与 2FA 同页 `/agent/settings/security`
 * （password 兼容旧路径，与现网实现一致）。
 */
export function isSetupPath(pathname: string | null | undefined): boolean {
  const path = (pathname ?? '').toLowerCase();
  return path.includes('password') || path.includes('security');
}

/**
 * 是否允许渲染业务 Outlet：
 * - ready → true
 * - loading → false（等待探测）
 * - error → 仅设置页路径豁免，其余一律 false（AC-6.6/6.8）
 */
export function canRenderOutlet(input: {
  phase: SetupPhase;
  pathname: string | null | undefined;
}): boolean {
  if (input.phase === 'ready') return true;
  if (input.phase === 'error') return isSetupPath(input.pathname);
  return false;
}
